import styled from "styled-components";

export const Wrapper = styled.div`
    height: calc(100vh - 150px);
    
    h5 {
        color: #0042ff;
        font-family: "Baloo Bhai 2";
        font-size: 16.8px;
        font-weight: bold;
    }
    
    span {
        font-family: "Baloo Bhai 2";
        width: 55%;
        text-align: center;
    }
`